<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule"  size="small" ref="dataForm"  label-width="120px"
     v-loading="dataLoading" style="width:100%;"  element-loading-text=""  element-loading-spinner="el-icon-loading"
    >
      <el-form-item label="分组编号" prop="performanceNo">
        <el-input v-model="dataForm.performanceNo" placeholder="分组编号"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="分组名称" prop="performanceName">
        <el-input v-model="dataForm.performanceName" placeholder="分组名称"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="膜厚" prop="thickness">
        <el-input v-model="dataForm.thickness" placeholder="膜厚"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="弯曲" prop="bend">
        <el-input v-model="dataForm.bend" placeholder="弯曲"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="冲击" prop="attack">
        <el-input v-model="dataForm.attack" placeholder="冲击"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="划格" prop="delimit">
        <el-input v-model="dataForm.delimit" placeholder="划格"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="杯突" prop="cupular">
        <el-input v-model="dataForm.cupular" placeholder="杯突"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="其他" prop="other">
        <el-input v-model="dataForm.other" placeholder="其他"  size="small" maxlength="30"></el-input>
      </el-form-item>
      <el-form-item label="分组说明" prop="description">
        <div style="margin: 20px 0;"></div>
        <el-input
                type="textarea"
                :rows="5"
                placeholder="分组说明"
                v-model="dataForm.description"
                maxlength="150"
                show-word-limit
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()" size="small"  :disabled="dataLoading">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {info,add,update} from '@/api/modules/performance'
  export default {
    data () {
      return {
        visible: false,
        dataLoading: false,
        dataForm: {
          id: 0,
          performanceNo: '',
          performanceName: '',
          description: '',
          thickness: '',
          bend: '',
          attack: '',
          delimit: '',
          cupular: '',
          other: ''
        },
        dataRule: {
          performanceNo: [
            { required: true, message: '分组编号不能为空', trigger: 'blur' }
          ],
          performanceName: [
            { required: true, message: '分组名称不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            info({id:this.dataForm.id}).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.performanceNo = data.performance.performanceNo
                this.dataForm.performanceName = data.performance.performanceName
                this.dataForm.description = data.performance.description
                this.dataForm.thickness = data.performance.thickness
                this.dataForm.bend = data.performance.bend
                this.dataForm.attack = data.performance.attack
                this.dataForm.delimit = data.performance.delimit
                this.dataForm.cupular = data.performance.cupular
                this.dataForm.other = data.performance.other
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
          	this.dataLoading = true;
            var params = {
              'id': this.dataForm.id || undefined,
              'performanceNo': this.dataForm.performanceNo,
              'performanceName': this.dataForm.performanceName,
              'description': this.dataForm.description,
              'thickness': this.dataForm.thickness,
              'bend': this.dataForm.bend,
              'attack': this.dataForm.attack,
              'delimit': this.dataForm.delimit,
              'cupular': this.dataForm.cupular,
              'other': this.dataForm.other,
            }
            var tick = !this.dataForm.id ? add(params) : update(params)
            tick.then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false;
	              	this.dataLoading = false;
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
                this.dataLoading = false;
              }
            })
          }
        })
      }
    }
  }
</script>
